<template>
  <div class="picker-wrapper">
    <i class="el-icon-arrow-left" @click="subtractOneDay"></i>
    <el-date-picker
      @change="emitNewDate"
      v-model="currentDate"
      type="date"
      format="MMMM, dd"
      :clearable="false"
      value-format="timestamp"
      placeholder="Pick a day">
    </el-date-picker>
    <i class="el-icon-arrow-right" @click="addOneDay"></i>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'DatePicker',
  props: ['value'],
  data() {
    return {
      currentDate: this.value,
    };
  },
  methods: {
    subtractOneDay() {
      this.currentDate = moment(this.currentDate).subtract(1, 'day').valueOf();
      this.emitNewDate();
    },
    addOneDay() {
      this.currentDate = moment(this.currentDate).add(1, 'day').valueOf();
      this.emitNewDate();
    },
    emitNewDate() {
      this.$emit('input', this.currentDate);
    },
  },
};
</script>

<style lang="scss" scoped>
  .picker-wrapper {
    // background: $primary-light;
    color: $highlight;
    padding: 0.5rem;
    border-radius: 1.25rem;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: center ;
    border: 1px solid $highlight;
    // border: 1px solid #a0a0a0;
    border-radius: 6px;
  }

  ::v-deep.el-date-editor--date {
    // width: 100%;
    .el-input__inner {
      font-size: 1.25rem;
      background: none;
        border: none;
        color: $highlight;
        text-align: center !important;
        font-family: 'BrownStd-Bold';
        caret-color: transparent;
        cursor: pointer;
    }
  }

  img {
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
  }
</style>
